var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H14.4V9.6H18C18.9548 9.6 19.8705 9.22072 20.5456 8.54559C21.2207 7.87045 21.6 6.95478 21.6 6C21.6 5.04522 21.2207 4.12955 20.5456 3.45442C19.8705 2.77928 18.9548 2.4 18 2.4H14.4V0H18C19.5913 0 21.1174 0.632141 22.2426 1.75736C23.3679 2.88258 24 4.4087 24 6C24 7.5913 23.3679 9.11742 22.2426 10.2426C21.1174 11.3679 19.5913 12 18 12ZM9.6 12H6C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0H9.6V2.4H6C5.04522 2.4 4.12955 2.77928 3.45442 3.45442C2.77928 4.12955 2.4 5.04522 2.4 6C2.4 6.95478 2.77928 7.87045 3.45442 8.54559C4.12955 9.22072 5.04522 9.6 6 9.6H9.6V12ZM18 7.2H6V4.8H18V7.2Z",
    fill: "currentcolor"
  })));
}

export default SvgLinkIcon1;